import { useEffect, useState } from "react";
import axios from "axios";
import { Autocomplete, TextField, MenuItem } from "@mui/material";

export default function Create({formik}) {
    const [teams, setTeams] = useState([]);
    const [emailTemplates, setEmailTemplates] = useState([]);

    const [preview1, setPreview1] = useState(null);

    useEffect(() => {
        getTeams()
        getEmailTemplates() 
    }, [])

    const getTeams = async () => {
        await axios.get(`/api/teams`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setTeams(result.data)
            }
        })
    }

    const getEmailTemplates = async () => {
        await axios.get(`/api/email_templates?status=1`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setEmailTemplates(result.data)
            }
        })
    }

    const handleLogoChange = (e, fieldName, setPreview) => {
        const file = e.target.files[0];
        if (file) {
        formik.setFieldValue(fieldName, file);
        setPreview(URL.createObjectURL(file));
        }
    };

    const handleTeamChange = (e, value) => {
        // console.log(value)
        if(value && value.id){
            formik.setFieldValue('team', value)
        }
        else{
            formik.setFieldValue('team', null)
        }
        
    }

    const handleEmailTemplateChange = (e, value) => {
        // console.log(value)
        if(value && value.id){
            formik.setFieldValue('emailTemplate', value)
        }
        else{
            formik.setFieldValue('emailTemplate', null)
        }
        
    }

    return (
        <div className="row py-4">
            <div className="col-md-6 offset-md-3 mt-4">
                <h3 className="heading fs_20">Create Assessment</h3>
                {/* <div className="">
                    <label className="form-label" htmlFor="basic-icon-default-name">Assessment Name</label>
                    <div className="input-group input-group-merge">
                        <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                        <input type="text" name="name" className="form-control" id="basic-icon-default-name" placeholder="Assessment Name" aria-label="Assessment Name" aria-describedby="basic-icon-default-fullname2"
                            onChange={formik.handleChange} 
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                        />
                    </div>
                    {formik.touched.name && formik.errors.name && (<div className="text-danger">{formik.errors.name}</div>)}
                </div> */}
            </div>
            <div className="col-md-6 offset-md-3 mt-4">
                <label className="form-label" htmlFor="basic-icon-default-phone">Organization</label>   
                <Autocomplete
                    id="team"
                    sx={{ width: 'auto' }}
                    size='small'
                    options={teams}
                    getOptionLabel={(option) => option.name}
                    onChange={handleTeamChange}
                    value={formik.values.team || null }
                    renderInput={(params) => <TextField {...params} label={"Select Organization"} />}
                />
                {formik.touched.team && formik.errors.team && (
                    <div className="text-danger">{formik.errors.team}</div>
                )}                                          
            </div>
            <div className="col-md-6 offset-md-3 mt-4">
                <label className="form-label" htmlFor="basic-icon-default-phone">Email Template</label>   
                <Autocomplete
                    id="emailTemplate"
                    sx={{ width: 'auto' }}
                    size='small'
                    options={emailTemplates}
                    getOptionLabel={(option) => option.name}
                    onChange={handleEmailTemplateChange}
                    value={formik.values.emailTemplate || null }
                    renderInput={(params) => <TextField {...params} label={"Select Email Template"} />}
                />
                {formik.touched.emailTemplate && formik.errors.emailTemplate && (
                    <div className="text-danger">{formik.errors.emailTemplate}</div>
                )}                                          
            </div>
            {/* Scale Dropdown */}
            <div className="col-md-6 offset-md-3 mt-4">
                <label className="form-label" htmlFor="basic-icon-default-phone">Scale Points</label>  
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Select Scale Point"
                    name="scalePoint"
                    value={formik.values.scalePoint || ''}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="5">5-point</MenuItem>
                    <MenuItem value="7">7-point</MenuItem>
                </TextField>
                {formik.touched.scalePoint && formik.errors.scalePoint && (
                    <div className="text-danger">{formik.errors.scalePoint}</div>
                )}
            </div>
            {/* Measurement Dropdown */}
            <div className="col-md-6 offset-md-3 mt-4">
                <label className="form-label" htmlFor="basic-icon-default-phone">Measurement Type</label>  
                <TextField
                    select
                    fullWidth
                    size="small"
                    label="Select Measurement Type"
                    name="measurementType"
                    value={formik.values.measurementType || ''}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="Frequency">Frequency</MenuItem>
                    <MenuItem value="Quality">Quality</MenuItem>
                    <MenuItem value="Agreement">Agreement</MenuItem>
                    <MenuItem value="Proficiency">Proficiency</MenuItem>
                    <MenuItem value="Demonstration">Demonstration</MenuItem>
                </TextField>
                {formik.touched.measurementType && formik.errors.measurementType && (
                    <div className="text-danger">{formik.errors.measurementType}</div>
                )}
            </div>
            {/* Logo 1 */}
            <div className="col-md-6 offset-md-3 mt-4">
                <label className="form-label">Logo</label>

                <div className="d-flex align-items-center gap-3">
                    <input type="file" accept="image/*" className="form-control" onChange={(e) => handleLogoChange(e, "logo1", setPreview1)}/>
                    {preview1 ? (
                    <img 
                        src={preview1} alt="Logo1"
                        style={{height: "60px",width: "auto",objectFit: "contain",border: "1px solid #ddd",padding: "4px",borderRadius: "6px"}}
                    />
                    ) : formik.values.logo1 && typeof formik.values.logo1 === "string" ? (
                    <img
                        src={formik.values.logo1}
                        alt="Logo1"
                        style={{height: "60px",width: "auto",objectFit: "contain",border: "1px solid #ddd",padding: "4px",borderRadius: "6px"}}
                    />
                    ) : null}
                </div>
                {formik.touched.logo1 && formik.errors.logo1 && (
                    <div className="text-danger">{formik.errors.logo1}</div>
                )} 
            </div>
        </div>
    )
}